import { z } from "zod";

import { scheduleTriggerSchema } from "./schedule-time-based-trigger-schema";

export const triggerSchema = z.discriminatedUnion("type", [
  ...scheduleTriggerSchema.options,
]);
